var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27018_298803)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8317 11.6667H2.49837C2.17637 11.6667 1.91504 11.4059 1.91504 11.0833C1.91504 10.7608 2.17637 10.5 2.49837 10.5H11.8317C12.1543 10.5 12.415 10.7608 12.415 11.0833C12.415 11.4059 12.1543 11.6667 11.8317 11.6667Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91504 7.58366H2.49837C2.17637 7.58366 1.91504 7.32291 1.91504 7.00033C1.91504 6.67774 2.17637 6.41699 2.49837 6.41699H8.91504C9.23704 6.41699 9.49837 6.67774 9.49837 7.00033C9.49837 7.32291 9.23704 7.58366 8.91504 7.58366Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16504 3.49967H2.49837C2.17637 3.49967 1.91504 3.23892 1.91504 2.91634C1.91504 2.59376 2.17637 2.33301 2.49837 2.33301H7.16504C7.48704 2.33301 7.74837 2.59376 7.74837 2.91634C7.74837 3.23892 7.48704 3.49967 7.16504 3.49967Z",
    fill: "#484848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27018_298803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInput);
export default __webpack_public_path__ + "static/media/input.e7f10f910832d890fc304d1da063ac69.svg";
export { ForwardRef as ReactComponent };